import { render, staticRenderFns } from "./ComboStatus.vue?vue&type=template&id=1339e69a&scoped=true&"
import script from "./ComboStatus.vue?vue&type=script&lang=js&"
export * from "./ComboStatus.vue?vue&type=script&lang=js&"
import style0 from "./ComboStatus.vue?vue&type=style&index=0&id=1339e69a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1339e69a",
  null
  
)

export default component.exports